import Axios from 'axios'
import humps from 'humps'

import { getCookie, getJWT } from '../helpers/cookies.helper'

const refreshToken = getCookie(process.env.REACT_APP_REFRESH_COOKIE as string)
let retry = false
let requestQueue = [] as any

const onAccessTokenFetched = (token: string) => {
  requestQueue = requestQueue.map((callback: any) => callback(token))
}

const addToQueue = (callback: any) => {
  requestQueue.push(callback)
}

const Api = Axios.create({
  baseURL: `//${process.env.REACT_APP_API_URL}`,
})

Api.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getJWT()}` || null
    if (!(config.data instanceof FormData)) {
      config.data = humps.decamelizeKeys(config.data)
    }
    // const { language } = I18n
    // config.params = { locale: language, ...config.params }
    return config
  },
  (error) => Promise.reject(error)
)

Api.interceptors.response.use(
  (response) => {
    response.data = humps.camelizeKeys(response.data)
    return response
  },
  async (error) => {
    return errorInterceptor(error)
  }
)

const getRefreshToken = async () => {
  const baseUrl = process.env.REACT_APP_MASTER_API as string
  return Axios.post(
    `${baseUrl}/auth/refresh_token`,
    { refresh_token: refreshToken },
    { headers: { jwt: getJWT() } }
  )
    .then(({ data: { jwt, refresh_token } }: any) => {
      return { jwt, refresh_token }
    })
    .catch((err) => {
      console.error(err)
      return { jwt: '', refresh_token: '' }
    })
}

const errorInterceptor = async (error: any) => {
  const originalRequest = error.config
  if (error.response.status === 419) {
    const needRetry = new Promise((resolve) => {
      addToQueue((access_token: any) => {
        try {
          originalRequest.headers.Authorization = 'Bearer ' + access_token
          resolve(Api(originalRequest))
        } catch (err) {
          console.error(err)
        }
      })
    })

    if (!retry) {
      try {
        retry = true
        const access_token = await getRefreshToken()
        retry = false

        document.cookie = `${process.env.REACT_APP_JWT_COOKIE as string}=${
          access_token.jwt
        }; Path=/; Domain=${process.env.REACT_APP_COOKIE_DOMAIN}`
        document.cookie = `${process.env.REACT_APP_REFRESH_COOKIE as string}=${
          access_token.refresh_token
        }; Path=/; Domain=${process.env.REACT_APP_COOKIE_DOMAIN}`

        Api.defaults.headers.Authorization = 'Bearer ' + access_token.jwt
        onAccessTokenFetched(access_token.jwt)
        requestQueue = []
      } catch (error) {
        console.error(error)
      }
    }
    return needRetry
  }

  error.data = humps.camelizeKeys(error.data)
  return Promise.reject(error)
}

export const LinksApi = Axios.create({
  baseURL: process.env.REACT_APP_LINKS_API,
})

LinksApi.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getJWT()}` || null
    return config
  },
  (error) => Promise.reject(error)
)

LinksApi.interceptors.response.use(
  (response) => {
    response.data = humps.camelizeKeys(response.data)
    return response
  },
  async (error) => {
    return errorInterceptor(error)
  }
)

export default Api
